import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { PlanningSegment } from "@app/models/rest/planning-segment";

@Injectable({
  providedIn: "root"
})
export class PlanningSegmentRestService extends HateoasResourceOperation<PlanningSegment> {
  constructor() {
    super(PlanningSegment);
  }
}
